// frontend/src/services/sessionsAPI.ts
import api from './apiConfig';

export interface ActiveSession {
    userId: number | string;
    usuario: string;
    base: number | string;
    role: 'admin' | 'diretor' | 'supervisor' | 'user';
    lastActivity: string;
    loginTime: string;
    ip?: string;
    userAgent?: string;
    status?: 'online' | 'offline';
}

export interface SessionStats {
    totalActiveSessions: number;
    cacheHits: number;
    cacheMisses: number;
    cacheKeys: number;
    adminSessions: number;
    supervisorSessions: number;
    userSessions: number;
}

export interface GetSessionsResponse {
    success: boolean;
    total: number;
    sessions: ActiveSession[];
}

export interface GetStatsResponse {
    success: boolean;
    stats: SessionStats;
}

/**
 * Obtém todas as sessões ativas
 */
export const getAllActiveSessions = async (): Promise<GetSessionsResponse> => {
    try {
        const response = await api.get('/sessions');
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar sessões ativas:', error);
        throw error;
    }
};

/**
 * Obtém estatísticas das sessões ativas
 */
export const getSessionStats = async (): Promise<GetStatsResponse> => {
    try {
        const response = await api.get('/sessions/stats');
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar estatísticas de sessões:', error);
        throw error;
    }
};

/**
 * Força logout de um usuário específico
 */
export const forceLogoutUser = async (userId: number | string): Promise<void> => {
    try {
        await api.delete(`/sessions/${userId}`);
    } catch (error) {
        console.error('Erro ao desconectar usuário:', error);
        throw error;
    }
};

/**
 * Limpa todas as sessões ativas
 */
export const clearAllSessions = async (): Promise<void> => {
    try {
        await api.delete('/sessions');
    } catch (error) {
        console.error('Erro ao limpar todas as sessões:', error);
        throw error;
    }
};
